<template>
  <div v-show="showcompareclose">
    <img
      @click="handlCompareClose"
      label="123"
      class="compare"
      :src="src"
      style="width: 40px; height: 40px; z-index: 2"
    />
    <div class="leftselect">
      <div
        class="selectoption"
        @click="handleChangeLeft(item)"
        :style="{ background: item.checked ? 'rgb(50, 103, 173)' : '' }"
        v-for="(item, index) in comparelist1"
        v-bind:key="index"
      >
        {{ item.label }}
      </div>
    </div>
    <div class="rightselect">
      <div
        class="selectoption"
        @click="handleChangeRight(item)"
        :style="{ background: item.checked ? 'rgb(50, 103, 173)' : '' }"
        v-for="(item, index) in comparelist2"
        v-bind:key="index"
      >
        {{ item.label }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "scrollCompare",
  data() {
    return {
      comparelist1: [],
      comparelist2: [],
      showcompareclose: false,
      src: require("../../../static/img/close.png"),
      leftlayer: "",
      rightlayer: "",
    };
  },
  methods: {
    handlCompareClose() {
      map3d_viewer.viewer.mouseHandlerManager.trigger("setTileseShow", true);
      map3d_viewer.viewer.mouseHandlerManager.trigger("showlist", true);
      this.showcompareclose = false;
      if (map3d_viewer.r && map3d_viewer.r.end) {
        map3d_viewer.r.end();
        map3d_viewer.viewer.mouseHandlerManager.trigger("compareState", false);
        map3d_viewer.r = null;
      }
    },
    handleChangeLeft(layers) {
      this.comparelist1.forEach((item) => {
        item.checked = false;
      });
      layers.checked = true;
      map3d_viewer.r.addLeftLayer("UrlTemplateImageryProvider", {
        url: layers.url,
      });
    },
    handleChangeRight(layers) {
      this.comparelist2.forEach((item) => {
        item.checked = false;
      });
      layers.checked = true;
      map3d_viewer.r.addRightLayer("UrlTemplateImageryProvider", {
        url: layers.url,
      });
    },
  },
  mounted() {
    map3d_viewer.viewer.mouseHandlerManager.listen("scrollCompareStart", (config) => {
      map3d_viewer.viewer.mouseHandlerManager.trigger("setTileseShow", false);
      this.comparelist1 = [];
      this.comparelist2 = [];
      window.compareLayerConfig.forEach((item) => {
        this.comparelist1.push({
          label: item.label,
          url: item.url,
          checked: false,
        });
        this.comparelist2.push({
          label: item.label,
          url: item.url,
          checked: false,
        });
      });
      if (config) {
        map3d_viewer.r = new map3d.FunctionTemplete.RollCompareAnalysis();
        map3d_viewer.r.start();
        this.showcompareclose = true;
      }
    });
  },
};
</script>

<style scoped>
.compare {
  color: white;
  justify-content: center;
  position: absolute;
  left: 98.5%;
  cursor: pointer;
  top: 10%;
  height: 400px;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  background: transparent;
  font-size: 40px;
}
.leftselect {
  overflow-y: auto;
  padding-top: 200px;
  width: 200px;
  height: 1080px;
  background: #000;
  color: #fff;
  position: absolute;
  left: 0%;
  cursor: pointer;
  top: 6.5%;
}
.rightselect {
  overflow-y: auto;
  padding-top: 200px;
  width: 200px;
  height: 1080px;
  background: #000;
  color: #fff;
  position: absolute;
  right: 0%;
  cursor: pointer;
  top: 6.5%;
}
.selectoption {
  margin: 10px;
  font-size: 20px;
  font-weight: 100;
  background: rgb(28, 28, 28);
}
.selectoption:hover {
  background: rgb(50, 103, 173);
}
</style>



// WEBPACK FOOTER //
// src/components/layout/scrollCompare.vue